import { defineProperty as _defineProperty } from '../../../../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import { usePathContext } from '../../../../../context/PathContext.js';
import classNames from 'classnames';
import Lock from './lock.svg.js';
import AlertDisable from './alert-disable.svg.js';
import styles from './styles.css.js';

var ContactTCPACompliance = function ContactTCPACompliance() {
  var pathContext = usePathContext();
  return React.createElement(React.Fragment, null, React.createElement("div", {
    className: classNames(styles.row, _defineProperty({}, styles.placementModal, pathContext.pathPlacement === 'modal'))
  }, React.createElement("div", {
    className: styles.graphic
  }, React.createElement(Lock, {
    className: styles.icon
  })), React.createElement("div", {
    className: styles.copy
  }, "By clicking Submit, you agree to receive text messages from Curated.com, and agree to our", ' ', React.createElement("a", {
    href: "https://www.curated.com/legal/terms-conditions",
    className: styles.link,
    target: "_blank"
  }, " Terms "), ' ', "and", ' ', React.createElement("a", {
    href: "https://www.curated.com/legal/privacy-policy",
    className: styles.link,
    target: "_blank"
  }, " Privacy Policy."), ' ', "Message & data rates may apply.")), React.createElement("div", {
    className: styles.row
  }, React.createElement("div", {
    className: styles.graphic
  }, React.createElement(AlertDisable, {
    className: styles.icon
  })), React.createElement("div", {
    className: styles.copy
  }, "Text STOP to opt out or HELP for help")));
};

export default ContactTCPACompliance;
//# sourceMappingURL=index.js.map
